import React, { useEffect, useState } from 'react';
import './login.component.sass';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import { Config } from '../../../config/config';
import { Input } from '../../../components/interface/input/input';
import { Button, ButtonSize, ButtonType } from '../../../components/interface/button/button';
import {
    CheckboxStyle as checkBoxStyle,
    InputCheckbox
} from '../../../components/interface/input/checkbox/input-checkbox';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSessionService } from '../../../services/session/use-session.service';

const FormSchema = Yup.object().shape({
    username: Yup.string().email('Email nieprawidłowy!').required('Pole wymagane!'),
    password: Yup.string().min(6, 'Za krótkie').required('Pole wymagane!'),
});

export const Login = (isOpen = true) => {

    const history = useHistory();
    const [isLoginError, setIsLoginError] = useState(false);
    const { login } = useSessionService();
    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: FormSchema,
        onSubmit: values => {
            login({username: values.username.toLowerCase(), password: values.password}).then(() => {
                setIsLoginError(false);
                toast.success('Zalogowany pomyślnie!');
                history.push(Config.routePaths.main.vendor.configuration.path);
            }, () => {
                toast.error('Błędne email lub hasło');
                setIsLoginError(true);
            });
        }
    });

    useEffect(() => {
        setIsLoginError(false);
    }, [formik.values]);

    useEffect(() => {
        return () => {
            formik.resetForm();
            setIsLoginError(false);
        };
    }, [isOpen]);

    return (
        <div className='vv-login'>
            <form onSubmit={formik.handleSubmit}>
                <div className='vv-login__input'>
                    <Input type='text'
                           placeholder='Email'
                           name='username'
                           id='username'
                           onChange={formik.handleChange}
                           onBlur={formik.handleBlur}
                           value={formik.values.username}
                           label='Email'
                           textError={(formik.touched.username && formik.errors.username) || isLoginError}/>
                </div>
                <div className='vv-login__input'>
                    <Input type='password'
                           placeholder='Password'
                           name='password'
                           id='password'
                           onChange={formik.handleChange}
                           onBlur={formik.handleBlur}
                           value={formik.values.password}
                           label='Hasło'
                           textError={(formik.touched.password && formik.errors.password) || isLoginError}/>
                </div>
                <div className='vv-login__checbox-container'>
                    <div className='checkbox'>
                        <InputCheckbox label='Zapamiętaj mnie'
                                       name='rememberme'
                                       id='rememberme'
                                       style={checkBoxStyle.SECONDARY}
                                       value=''/>
                    </div>
                    <p>Nie pamiętam hasła</p>
                </div>
                <div className='vv-login__button'>
                    <Button className='vv-login__button' type='submit' text='Zaloguj' size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK}/>
                </div>
            </form>
        </div>
    );
};
